import { createStore } from "vuex";

export default createStore({
  state: {
    // Define your global state here
  },
  mutations: {
    // Define your mutations here
  },
  actions: {
    // Define your actions here
  },
  modules: {
    // Define your modules here
  },
});
